
namespace Sintra {

	//export type DistinctArray<T> = Set<T>;

	export class DistinctArray<T>  {

		private _set: Array<T>;
	
		constructor(values?: T[]) {
			this._set = values || [];
		}
	
	
		private _findIndex(v: T) {
			const typeofValue = typeof v;
			let isValueNaN = false;
			let isValueUndefined = typeofValue === "undefined";
			if (typeofValue === "number") {
				isValueNaN = isNaN(v as unknown as number);
			}
			let index = 0;
			for (const item of this._set) {
				if (item === undefined && isValueUndefined) {
					return index;
				}
				else if (isValueNaN && typeof item === "number" && isNaN(item)) {
					return index;
				}
				else {
					if (item === v) {
						return index;
					}
				}
				index++;
			}
			return -1;
		}
	
	
		public add(value: T) {
			if (this._findIndex(value) >= 0) {
				return;
			}
			this._set.push(value);
		}
	
		public clear() {
			this._set = [];
		}
	
		public delete(value: T) {
			const index = this._findIndex(value);
			if (index >= 0) {
				this._set = this._set.splice(index, 1);
			}
		}
	
		public has(value: T) {
			return this._findIndex(value) >= 0;
		}
	
		public keys() {
			return this._set.slice(0);
		}
	
		public values() {
			return this._set.slice(0);
		}
	
		public entries() {
			return this._set.map(x => [x, x]);
		}
	
		public forEach(callback: (value: T, key?: T, set?: DistinctArray<T>) => void) {
			if (typeof callback !== "function") {
				throw new Error("expected function");
			}
			for (const item of this._set) {
				callback(item, item, this);
			}
		}

		public toArray() {
			return this._set.slice(0);
		}
	}
}


